/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rate: NonNullable<unknown> }} Ccsl_Export_Metadata_Frame_RateInputs */



/**
* | output |
* | --- |
* | "Frame Rate: {rate}" |
*
* @param {Ccsl_Export_Metadata_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_frame_rate = /** @type {((inputs: Ccsl_Export_Metadata_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Frequence d'images : ${i?.rate}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bildrate: ${i?.rate}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Frequenza fotogrammi: ${i?.rate}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Частота кадров: ${i?.rate}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Velocidad de fotogramas: ${i?.rate}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`帧率：${i?.rate}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームレート: ${i?.rate}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ्रेम दर: ${i?.rate}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Taxa de quadros: ${i?.rate}`)
	return /** @type {LocalizedString} */ (`Frame Rate: ${i?.rate}`)
});